import events from '../../../events.js'
import {googleAds} from '../../../externalTrackers/index.js'

const {RESERVATION_SUCCESS} = events

const CONVERSION_ID = 'AW-1054000236'
const RESERVATION_SUCCESS_LABEL = 'gHTcCLPjzLEcEOyIy_YD'

const track = googleAds({id: CONVERSION_ID})

export default ({event}) => {
  if (event === RESERVATION_SUCCESS) {
    track({label: RESERVATION_SUCCESS_LABEL})
  }
}
